import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'see-more',
  styleUrls: ['./see-more.component.scss'],
  templateUrl: './see-more.component.html'
})
export class SeeMoreComponent {
  faCaretDown = faCaretDown;
  faCaretUp = faCaretUp;
  readMoreTogglerText: string;

  @Input() expanded = false;
  @Output()
  clicked: EventEmitter<unknown> = new EventEmitter<unknown>();

  constructor() {}

  ngOnInit() {
    this.readMoreTogglerText = this.expanded
      ? $localize`:@@news.readLess:Read less`
      : $localize`:@@news.readMore:Read more`;
  }

  handleClick() {
    this.clicked.emit(true);
  }
}
